function calculateDaysToField( thisField, withTarget, toTarget, pickerOptions ) {
	if( toTarget && withTarget ) {
		let withTargetVal = withTarget.value;
		let thisVal = thisField.value;

		if( thisVal && withTargetVal ) {
			let withTargetDate = flatpickr.parseDate( withTargetVal, pickerOptions.dateFormat );
			let thisFieldDate = flatpickr.parseDate( thisVal, pickerOptions.dateFormat );
			let differenceMs = Math.abs( withTargetDate - thisFieldDate );
			let differenceDays = Math.round( differenceMs / 60 / 60 / 24 / 1000 );

			toTarget.value = differenceDays;
		}
	}
}

function sendDatePartToField( thisField, datePart, toTarget, pickerOptions ) {
	let thisVal = thisField.value;

	if( thisVal && toTarget ) {
		let dateObject = flatpickr.parseDate( thisVal, pickerOptions.dateFormat );
		let thePart = flatpickr.formatDate( dateObject, datePart );
		toTarget.value = thePart;
	}
}

export function initFlatpickr( thisField ) {
	let pickerOptions = {
		altInput: true,
		locale: window.bonesGlobals.languageCode,
		static: true,
		onChange: function( selectedDates, dateStr, instance ) {
			// La date choisie dans ce champ influence le minimum d'un autre champ

			if( thisField.dataset.setsMinOf ) {
				let minTarget = document.querySelector( thisField.dataset.setsMinOf );
				let minTargetInstance = minTarget ? minTarget._flatpickr : null;

				// A-t-on sélectionné des dates? Est-ce que la cible est un flatpickr?
				if( minTargetInstance && selectedDates.length ) {
					let minTargetDates = minTargetInstance.selectedDates;
					let newMinTargetDates = [];
					let newMinDate = selectedDates.length ? selectedDates[ selectedDates.length - 1 ] : null;
					let newMinDateMs = newMinDate ? newMinDate.getTime() : null;
					let newMinDateNextDay = new Date( newMinDate.getTime() );
					newMinDateNextDay = new Date( newMinDateNextDay.setDate( newMinDateNextDay.getDate() + 1 ) );


					// On fait le tour des dates de la cible et on garde juste celles qui sont après le minimum.

					if( newMinDate && minTargetDates.length ) {
						minTargetDates.forEach( function( thisTargetDate ) {
							let thisTargetDateMs = thisTargetDate.getTime();

							// Différence négative = la date cible est après le minimum! Parfait.
							if( newMinDateMs - thisTargetDateMs < 0 ) {
								newMinTargetDates.push( thisTargetDate );
							}
						} );
					}

					// On a enlevé toutes les dates avant le minimum du champ cible. S'il ne reste plus de date, on met le minimum par défaut.

					if( ! newMinTargetDates.length ) {
						// Utiliser newMinDate pour sélectionner la même date.
						// Utiliser newMinDateNextDay pour sélectionner le lendemain.
						newMinTargetDates.push( newMinDateNextDay );
					}

					// Application du tout au champ

					minTargetInstance.set( 'minDate', newMinDate );
					minTargetInstance.setDate( newMinTargetDates );
				}
			}

			
			// La date choisie dans ce champ influence le maximum d'un autre champ

			if( thisField.dataset.setsMaxOf ) {
				let maxTarget = document.querySelector( thisField.dataset.setsMaxOf );
				let maxTargetInstance = maxTarget ? maxTarget._flatpickr : null;

				// A-t-on sélectionné des dates? Est-ce que la cible est un flatpickr?
				if( maxTargetInstance && selectedDates.length ) {
					let maxTargetDates = maxTargetInstance.selectedDates;
					let newMaxTargetDates = [];
					let newMaxDate = selectedDates.length ? selectedDates[0] : null;
					let newMaxDateMs = newMaxDate ? newMaxDate.getTime() : null;
					let newMaxDatePrevDay = new Date( newMaxDate.getTime() );
					newMaxDatePrevDay = new Date( newMaxDatePrevDay.setDate( newMaxDatePrevDay.getDate() - 1 ) );


					// On fait le tour des dates de la cible et on garde juste celles qui sont après le maximum.

					if( newMaxDate && maxTargetDates.length ) {
						maxTargetDates.forEach( function( thisTargetDate ) {
							let thisTargetDateMs = thisTargetDate.getTime();

							// Différence positive = la date cible est avant ou directement sur le maximum! Parfait.
							if( newMaxDateMs - thisTargetDateMs >= 0 ) {
								newMaxTargetDates.push( thisTargetDate );
							}
						} );
					}

					// On a enlevé toutes les dates avant le maximum du champ cible. S'il ne reste plus de date, on met le maximum par défaut.

					if( ! newMaxTargetDates.length ) {
						// Utiliser newMaxDate pour sélectionner la même date.
						// Utiliser newMaxDatePrevDay pour sélectionner la veille.
						newMaxTargetDates.push( newMaxDatePrevDay );
					}

					// Application du tout au champ

					maxTargetInstance.set( 'maxDate', newMaxDate );
					maxTargetInstance.setDate( newMaxTargetDates );
				}
			}


			// Deux dates ensemble calculent un nombre de jours dans un autre champ

			if( thisField.dataset.calculateTo && thisField.dataset.calculateWith ) {
				let toTarget = document.querySelector( thisField.dataset.calculateTo );
				let withTarget = document.querySelector( thisField.dataset.calculateWith );

				calculateDaysToField( thisField, withTarget, toTarget, pickerOptions )
			}


			// Le jour du champ va dans un autre champ

			if( thisField.dataset.dayTo ) {
				let toTarget = document.querySelector( thisField.dataset.dayTo );

				sendDatePartToField( thisField, 'd', toTarget, pickerOptions );
			}


			// Le mois du champ va dans un autre champ

			if( thisField.dataset.monthTo ) {
				let toTarget = document.querySelector( thisField.dataset.monthTo );

				sendDatePartToField( thisField, 'm', toTarget, pickerOptions );
			}


			// L'année du champ va dans un autre champ

			if( thisField.dataset.monthTo ) {
				let toTarget = document.querySelector( thisField.dataset.yearTo );

				sendDatePartToField( thisField, 'Y', toTarget, pickerOptions );
			}
		},
		onReady: function() {
			// Deux dates ensemble calculent un nombre de jours dans un autre champ
			if( thisField.dataset.calculateTo && thisField.dataset.calculateWith ) {
				let toTarget = document.querySelector( thisField.dataset.calculateTo );
				let withTarget = document.querySelector( thisField.dataset.calculateWith );

				calculateDaysToField( thisField, withTarget, toTarget, pickerOptions )
			}

			// Le jour du champ va dans un autre champ
			if( thisField.dataset.dayTo ) {
				let toTarget = document.querySelector( thisField.dataset.dayTo );

				sendDatePartToField( thisField, 'd', toTarget, pickerOptions );
			}

			// Le mois du champ va dans un autre champ
			if( thisField.dataset.monthTo ) {
				let toTarget = document.querySelector( thisField.dataset.monthTo );

				sendDatePartToField( thisField, 'm', toTarget, pickerOptions );
			}

			// L'année du champ va dans un autre champ
			if( thisField.dataset.monthTo ) {
				let toTarget = document.querySelector( thisField.dataset.yearTo );

				sendDatePartToField( thisField, 'Y', toTarget, pickerOptions );
			}
		},
	};

	// Format de date retourné lors du submit
	if( thisField.dataset.dateFormat ) {
		pickerOptions.dateFormat = thisField.dataset.dateFormat;
	} else {
		pickerOptions.dateFormat = 'Y-m-d';
	}

	// Format de date affiché
	if( thisField.dataset.altFormat ) {
		pickerOptions.altFormat = thisField.dataset.altFormat;
	} else {
		pickerOptions.altFormat = 'j F Y';
	}

	// Date par défaut. Attribut existant mais vide = champ vide par défaut. Pas d'attribut = défaut aujourd'hui.
	// Doit respecter pickerOptions.altFormat
	if( 'undefined' != typeof thisField.dataset.defaultDate ) {
		if( thisField.dataset.defaultDate ) {
			pickerOptions.defaultDate = flatpickr.parseDate( thisField.dataset.defaultDate, pickerOptions.dateFormat );
		}
	} else {
		pickerOptions.defaultDate = new Date();
		pickerOptions.defaultDate.setHours( 0, 0, 0, 0 );
	}

	// Date minimum. Attribut existant mais vide = pas de minimum. Pas d'attribut = minimum aujourd'hui.
	// Doit respecter pickerOptions.altFormat
	if( 'undefined' != typeof thisField.dataset.minDate ) {
		if( thisField.dataset.minDate ) {
			pickerOptions.minDate = flatpickr.parseDate( thisField.dataset.minDate, pickerOptions.dateFormat );
		} else {
			pickerOptions.minDate = null;
		}
	} else {
		pickerOptions.minDate = new Date();
		pickerOptions.minDate.setHours( 0, 0, 0, 0 );
	}

	// Date maximum. Attribut existant mais vide = pas de maximum. Pas d'attribut = pas de maximum.
	// Doit respecter pickerOptions.altFormat
	if( 'undefined' != typeof thisField.dataset.maxDate ) {
		if( thisField.dataset.maxDate ) {
			pickerOptions.maxDate = flatpickr.parseDate( thisField.dataset.maxDate, pickerOptions.dateFormat );
		}
	}

	// console.log( pickerOptions );
	let pickerInstance = flatpickr( thisField, pickerOptions );
}

export default initFlatpickr